import { persian } from '@roza/shared'

const fa = (n: number): string => persian.toPersianDigits(String(n))

/** 1250000 → «۱٬۲۵۰٬۰۰۰». */
export function faNumber(n: number): string {
  return persian.toPersianDigits(n.toLocaleString('en-US').replace(/,/g, '٬'))
}

export type SupportStatus = 'open' | 'pending_customer' | 'resolved' | 'closed'

export interface SupportRow {
  id: string
  status: SupportStatus
  status_label: string
  customer: { name: string; kind: 'customer' | 'guest' }
  preview: string | null
  unread: boolean
  assigned: { id: number; name: string } | null
  waiting_since: string | null
  blocked: boolean
  updated_at: string
}

export interface SupportMessage {
  id: string
  seq: number
  author: 'customer' | 'agent' | 'note' | 'system'
  admin_name: string | null
  body: string | null
  attachment: { id: string; mime: string; width: number | null; height: number | null } | null
  at: string
}

export interface SupportCard {
  name: string
  kind: 'customer' | 'guest'
  identifier: string | null
  member_since: string | null
  orders: Array<{ id: string; number: string; status_label: string; total_toman: number; placed_at: string | null }>
}

export interface SupportThread extends Omit<SupportRow, 'customer'> {
  context: { path?: string; sku?: string; product_name?: string; order_number?: string }
  customer: SupportCard
  messages: SupportMessage[]
}

/** «منتظر ۱۲ دقیقه» / «منتظر ۲ ساعت»: how long the customer has waited for the team. */
export function waitingLabel(since: string | null, now: Date): string | null {
  if (!since) return null

  const minutes = Math.max(0, Math.round((now.getTime() - new Date(since).getTime()) / 60_000))

  return minutes < 60 ? `منتظر ${fa(minutes)} دقیقه` : `منتظر ${fa(Math.floor(minutes / 60))} ساعت`
}

/** A conversation id above the highest one already seen means somebody new is waiting. */
export function isNewConversation(latest: number, seen: number): boolean {
  return latest > 0 && latest > seen
}
